// Hack because you can't extend enums currently:
// https://github.com/microsoft/TypeScript/issues/17592
export enum AssignedUserStatTypes {
  primary = 'primary',
  backup = 'backup',
  any = 'any',
}
